<template>
  <!-- 容器顶部截至时间选择器 -->
  <div  style="display: flex;align-items: center;margin-right:20px;">
    <div style="font-size: 14px;color: #606266;line-height: 14px;font-weight: 400;margin-right: 8px;">截止日期：</div>
    <el-date-picker
        v-model="selectDate"
        @change="dateChange"
        type="date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        placeholder="选择截止日期"
    >
    </el-date-picker>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import {getMonthStartDate} from "@/utils/util";
export default {
  name: "dataTime",
  data(){
    return {
      selectDate:getMonthStartDate().format('yyyy-MM-dd'),
    }
  },

  methods:{
    dateChange(date){
      this.$emit('changeDate',date)
    }
  }
}
</script>

<style scoped>

</style>